module.exports = __webpack_public_path__ + "static/media/quadro2.80aa15ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/quadro2.png
// module id = 54
// module chunks = 0